import { Quote, Star } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

const Testimonials = () => (
    <section className="py-24 lg:py-32" data-testid="testimonials-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <SectionHeading
                eyebrow="Genuine Testimonials"
                title="Families worldwide notice the difference within weeks"
                copy="Real words from real Hindi Ganga families — from New Jersey to Sydney to Toronto."
            />
            <div className="mt-14 grid gap-5 lg:grid-cols-3" data-testid="testimonials-grid">
                {TESTIMONIALS.map((t, i) => (
                    <Reveal key={t.name} delay={i * 0.1}>
                        <figure
                            className="flex h-full flex-col rounded-3xl border border-border bg-sand p-8 card-shadow transition-all duration-300 hover:-translate-y-1.5 hover:lift-shadow lg:p-10"
                            data-testid={`testimonial-card-${i}`}
                        >
                            <Quote className="h-8 w-8 text-saffron/50" />
                            <div className="mt-4 flex gap-1" aria-label="5 star rating">
                                {[...Array(5)].map((_, s) => (
                                    <Star key={s} className="h-4 w-4 fill-saffron text-saffron" />
                                ))}
                            </div>
                            <blockquote className="mt-5 flex-1 font-serif text-lg italic leading-relaxed text-ink">
                                "{t.quote}"
                            </blockquote>
                            <figcaption className="mt-7 border-t border-border pt-5">
                                <p className="text-sm font-medium text-ink">{t.name}</p>
                                <p className="mt-1 text-xs uppercase tracking-[0.14em] text-muted-foreground">{t.meta}</p>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
export default Testimonials;
